/**
 *
 * CollaboratorsUpdate
 *
 */

import React from "react"
import "./index.less"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Divider, Input, Checkbox, DatePicker, Select, Button } from "antd"
import moment from "moment"

import { range } from "lodash"
import ModalCustom from "components/ModalCustom"
import alertSvg from "../../images/alert.svg"
import { LeftOutlined } from "@ant-design/icons"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import { LOCAL_COMPANY_ID } from "../../utils/storage"

const MONTHS = [
  { name: "Enero", month: "01" },
  { name: "Febrero", month: "02" },
  { name: "Marzo", month: "03" },
  { name: "Abril", month: "04" },
  { name: "Mayo", month: "05" },
  { name: "Junio", month: "06" },
  { name: "Julio", month: "07" },
  { name: "Agosto", month: "08" },
  { name: "Septiembre", month: "09" },
  { name: "Octubre", month: "10" },
  { name: "Noviembre", month: "11" },
  { name: "Diciembre", month: "12" },
]

const InputGroup = Input.Group
const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
class CollaboratorsCreateTemplate extends React.Component {
  constructor() {
    super()
    this.onChange = this.onChange.bind(this)
  }

  state = {
    first_name: "",
    last_name: "",
    second_last_name: "",
    document: "",
    date_birth: "",
    date_admission: "",
    id_gender: "",
    id_division: "",
    position_name: "",
    email: "",
    id_currency: 1,
    id_position_level: "",
    id_employee_leader: "",
    phone: "",
    id_geographic_location: null,
    salary: "",
    errorName: false,
    errorData: false,
    errorDivision: false,
    errorPosition: false,
    errorDate: false,
    errorDateBirth: false,
    general_manager: 0,
    disabledButton: true,
    dateBirthSelected: null,
    dateAdmissionSelected: null,
  }

  onLeaveClicked = () => {
    const {
      first_name,
      last_name,
      second_last_name,
      document,
      position_name,
      email,
      phone,
      salary,
    } = this.state

    if (
      first_name.length == 0 &&
      last_name.length == 0 &&
      second_last_name.length == 0 &&
      document.length == 0 &&
      email.length == 0 &&
      position_name.length == 0 &&
      phone.length == 0 &&
      salary.length == 0
    ) {
      this.props.history.push("/organization#collaborators")
    } else {
      return this.setState({ modalBackOpen: true })
    }
  }

  onCreate = () => {
    const {
      first_name,
      last_name,
      second_last_name,
      document,
      date_birth,
      date_admission,
      id_gender,
      id_division,
      position_name,
      email,
      phone,
      salary,
      general_manager,
      id_position_level,
      id_currency,
      id_geographic_location,
      id_employee_leader,
    } = this.state

    woopraTrack("Aceptar Crear Colaborador")

    let {
      errorName,
      errorData,
      errorDivision,
      errorPosition,
      errorDate,
      errorDateBirth,
    } = false

    if (!this.state.dateAdmissionSelected) {
      errorDate = true
    }

    if (!this.state.dateBirthSelected) {
      errorDateBirth = true
    }

    if (first_name.length == 0 || last_name.length == 0) {
      errorName = true
    }

    // if (document.length == 0 || date_birth.length == 0 || id_gender.length == 0) {
    if (document.length == 0 || id_gender.length == 0) {
      errorData = true
    }

    if (id_division.length == 0) {
      errorDivision = true
    }

    if (position_name.length == 0) {
      errorPosition = true
    }

    this.setState(
      {
        errorName,
        errorData,
        errorDivision,
        errorPosition,
        errorDate,
        errorDateBirth,
      },
      () => {
        const check = this.checkInputs()
        if (check) {
          const params = {
            first_name,
            last_name,
            second_last_name,
            document,
            date_birth: this.state.dateBirthSelected ? this.state.dateBirthSelected.format("YYYY-MM-DD") : "",
            id_gender,
            id_division,
            position_name,
            email,
            id_currency,
            id_position_level,
            phone,
            id_geographic_location,
            salary,
            general_manager,
            id_employee_leader,
            date_admission: this.state.dateAdmissionSelected ? this.state.dateAdmissionSelected.format("YYYY-MM-DD") : "",
            id_company: LOCAL_COMPANY_ID(),
          }
          this.props.createCollaborator(params)
        }
      }
    )
  }

  onKeyUpClean = (option) => {
    const {
      first_name,
      last_name,
      document,
      date_birth,
      date_admission,
      id_gender,
      id_division,
      position_name,
      email,
      id_position_level,
    } = this.state

    switch (option) {
      case 1:
        if (first_name.length == 0 || last_name.length == 0) {
          this.setState({ errorName: true })
        } else {
          this.setState({
            errorName: false,
            disabledButton: false,
          })
        }
        break
      case 2:
        if (document.length == 0 || id_gender.length == 0) {
          this.setState({ errorData: true })
        } else {
          this.setState({
            errorData: false,
            disabledButton: false,
          })
        }
        if (!this.state.dateBirthSelected) {
          this.setState({ errorDateBirth: true })
        } else {
          this.setState({
            errorDateBirth: false,
            disabledButton: false,
          })
        }
        break
      case 3:
        if (id_division.length == 0) {
          this.setState({ errorDivision: true })
        } else {
          this.setState({
            errorDivision: false,
            disabledButton: false,
          })
        }
        break
      case 4:
        if (id_position_level.length == 0) {
        } else {
          this.setState({ disabledButton: false })
        }
        break
      case 5:
        if (email.length == 0) {
        } else {
          this.setState({ disabledButton: false })
        }
        break
      case 6:
        if (position_name.length == 0) {
          this.setState({
            errorPosition: true,
          })
        } else {
          this.setState({
            errorPosition: false,
            disabledButton: false,
          })
        }
        break
      case 7:
        if (!this.state.dateAdmissionSelected) {
          this.setState({
            errorDate: true,
          })
        } else {
          this.setState({
            errorDate: false,
            disabledButton: false,
          })
        }
        break
    }
  }

  checkInputs = () => {
    const {
      errorName,
      errorData,
      errorDivision,
      errorPosition,
      errorDate,
    } = this.state

    if (
      !errorName &&
      !errorDate &&
      !errorData &&
      !errorDivision &&
      !errorPosition
    ) {
      return true
    }
    return false
  }

  onChange(date, dateString) {
    this.setState(
      {
        date_birth: dateString,
        disabledButton: false,
      },
      () => {
        this.onKeyUpClean(2)
      }
    )
  }

  onChangeDate(name, value, key) {
    this.setState(
      {
        [name]: value,
        disabledButton: false,
      },
      () => {
        this.onKeyUpClean(key)
      }
    )
  }

  onChangeInput = (name, value) => {
    this.setState({
      [name]: value,
      disabledButton: false,
    })
  }

  onChangeCheckbox = (e) => {
    this.setState({
      general_manager: e.target.checked ? 1 : 0,
      disabledButton: false,
    })
  }

  onSelectChange = (name, value) => {
    if (typeof value === "undefined") {
      this.setState({
        [name]: "",
        disabledButton: false,
      })
    } else {
      this.setState(
        {
          [name]: value,
          disabledButton: false,
        },
        () => {
          switch (name) {
            case "id_gender":
              this.onKeyUpClean(2)
              break
            case "id_division":
              this.onKeyUpClean(3)
              break
          }
        }
      )
    }
  }

  daysInMonth = () => {
    const { monthSelected, yearSelected, daySelected } = this.state

    if (monthSelected && yearSelected) {
      const daysMonth = new Date(yearSelected, monthSelected, 0).getDate()

      if (daysMonth < Number(daySelected)) {
        this.setState({ daySelected: daysMonth })
      }

      return daysMonth
    }

    // Si aún no se ha seleccionado mes/año, mostrar siempre 31 días
    // para permitir fechas como 29, 30 y 31 desde el inicio.
    return 31
  }

  daysInMonthWork = () => {
    const {
      monthEntrySelected,
      yearEntrySelected,
      dayEntrySelected,
    } = this.state

    if (monthEntrySelected && yearEntrySelected) {
      const daysMonth = new Date(
        yearEntrySelected,
        monthEntrySelected,
        0
      ).getDate()

      if (daysMonth < Number(dayEntrySelected)) {
        this.setState({ dayEntrySelected: daysMonth })
      }

      return daysMonth
    }

    // Para fecha de ingreso, mismo criterio: por defecto 31 días.
    return 31
  }

  render() {
    const {
      isLoadingDivisions,
      isLoadingGenders,
      isLoadingLeaders,
      isLoadingCategories,
      isLoadingLocations,
      divisions,
      currency,
      categories,
      leaders,
      genders,
      locations,
      isCreating,
    } = this.props
    const {
      errorName,
      errorData,
      errorDivision,
      errorPosition,
      errorDate,
      errorDateBirth,
    } = this.state

    const redDot = () => <span className="red-dot">*</span>

    const selectAfter = (
      <Select
        defaultValue={currency.length > 0 && currency[0].id_currency}
        onChange={(e) => this.onSelectChange("id_currency", e)}>
        {currency.map((currency) => (
          <Option key={currency.id_currency} value={currency.id_currency}>
            {currency.symbol}
          </Option>
        ))}
      </Select>
    )
    const hasFreshchat =
      typeof window.Intercom !== "undefined" &&
      window.self === window.top;
    return (
      <div className="collaborators-container">
        <div className="collaborators-container-header">
          <div className="collaborators-container-btn-back">
            <span onClick={this.onLeaveClicked}>
              <LeftOutlined /> Colaboradores
            </span>
          </div>
          <span className="collaborators-container-tittle-2">
            Crear colaborador
          </span>
        </div>
        <div className="collaborators-container-box"  style={{ ...(typeof window.Intercom !== "undefined" &&
            window.self === window.top && {
            paddingBottom: "16px!important"}) }}>
          <div className="collaborators-container-box-divider">
            <span className="collaborators-container-box-divider-tittle">
              INFORMACIÓN PERSONAL
            </span>
            <Divider />
          </div>

          <div className="inputNameContainer">
            <div className="title-with-error">
              <h4>
                Nombre y Apellido
                {redDot()}
              </h4>
              {errorName && <div>Campos obligatorios</div>}
            </div>
            <InputGroup compact>
              <Input
                maxLength={80}
                style={{ width: "33.3%" }}
                onChange={(e) =>
                  this.onChangeInput("first_name", e.target.value)
                }
                placeholder="Nombre"
                onKeyUp={() => this.onKeyUpClean(1)}
              />
              <Input
                onKeyUp={() => this.onKeyUpClean(1)}
                maxLength={60}
                style={{ width: "33.3%" }}
                onChange={(e) =>
                  this.onChangeInput("last_name", e.target.value)
                }
                placeholder="Apellido paterno"
              />
              <Input
                onKeyUp={() => this.onKeyUpClean(1)}
                maxLength={60}
                style={{ width: "33.3%" }}
                onChange={(e) =>
                  this.onChangeInput("second_last_name", e.target.value)
                }
                placeholder="Apellido materno"
              />
            </InputGroup>
          </div>

          <div className="personal-data-container">
            <div className="inputs-grid">
              <div className="inputName">
                <h4>
                  DNI
                  <span>*</span>
                </h4>
                <Input
                  maxLength={32}
                  placeholder="DNI"
                  onChange={(e) =>
                    this.onChangeInput("document", e.target.value)
                  }
                  onKeyUp={() => this.onKeyUpClean(2)}
                />
              </div>
              <div className="inputName">
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <h4>
                    Fecha de nacimiento
                    <span>*</span>
                  </h4>
                  {errorDateBirth && (
                    <span className="laboral-info-item-error">
                      Campo obligatorio
                    </span>
                  )}
                </div>
                <DatePicker
                  format="DD/MM/YYYY"
                  placeholder="Fecha de nacimiento"
                  style={{ width: "100%" }}
                  value={this.state.dateBirthSelected}
                  disabledDate={(current) => current && current > moment().endOf("day")}
                  onChange={(date) => {
                    this.setState(
                      {
                        dateBirthSelected: date,
                        disabledButton: false,
                      },
                      () => this.onKeyUpClean(2)
                    )
                  }}
                />
              </div>
              <div className="inputName">
                <h4>
                  Género
                  <span>*</span>
                </h4>
                <Select
                  loading={isLoadingGenders}
                  disabled={isLoadingGenders}
                  style={{ width: "100%" }}
                  placeholder="Seleccionar"
                  onChange={(e) => this.onSelectChange("id_gender", e)}>
                  {genders.map((gender) => (
                    <Option value={gender.id_gender} key={gender.id_gender}>
                      {gender.name}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
            {errorData && (
              <div className="required-field-error">Campos obligatorios</div>
            )}
          </div>
          <div className="collaborators-container-box-divider">
            <span className="collaborators-container-box-divider-tittle">
              INFORMACIÓN LABORAL
            </span>
            <Divider />
          </div>
          <div className="collaborators-container-checkbox">
            <Checkbox onChange={this.onChangeCheckbox} />
            <div>
              Seleccionar como <strong>Gerente General</strong>
            </div>
          </div>
          <div className="laboral-info-container">
            <div className="laboral-info-item">
              <div className="laboral-info-item-header">
                <h4>
                  División
                  {redDot()}
                </h4>
                {errorDivision && (
                  <span className="laboral-info-item-error">
                    Campo obligatorio
                  </span>
                )}
              </div>
              <Select
                disabled={isLoadingDivisions}
                loading={isLoadingDivisions}
                style={{ width: "100%" }}
                placeholder="Seleccionar división"
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                onChange={(e) => {
                  this.onSelectChange("id_division", e)
                }}>
                {divisions.map((division) => (
                  <Option
                    key={division.id_division}
                    value={division.id_division}>
                    {division.name}
                  </Option>
                ))}
              </Select>
            </div>
            <div className="laboral-info-item">
              <div className="laboral-info-item-header">
                <h4>
                  Puesto
                  {redDot()}
                </h4>
                {errorPosition && (
                  <span className="laboral-info-item-error">
                    Campo obligatorio
                  </span>
                )}
              </div>
              <Input
                maxLength={160}
                placeholder="Ejemplo: Analista de Contabilidad"
                onChange={(e) =>
                  this.onChangeInput("position_name", e.target.value)
                }
                onKeyUp={() => this.onKeyUpClean(6)}
              />
            </div>
            <div className="laboral-info-item">
              <div className="laboral-info-item-header">
                <h4>Categoría jerárquica</h4>
              </div>
              <Select
                loading={isLoadingCategories}
                disabled={isLoadingCategories}
                style={{ width: "100%" }}
                placeholder="Seleccionar categoría"
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                onChange={(e) => this.onSelectChange("id_position_level", e)}>
                {categories.map((category) => (
                  <Option
                    key={category.id_position_level}
                    value={category.id_position_level}>
                    {category.name}
                  </Option>
                ))}
              </Select>
            </div>
            <div className="laboral-info-item">
              <div className="laboral-info-item-header">
                <h4>Email</h4>
              </div>
              <Input
                placeholder="ejemplo@ejemplo.com"
                onKeyUp={() => this.onKeyUpClean(5)}
                onChange={(e) => this.onChangeInput("email", e.target.value)}
              />
            </div>
            <div className="laboral-info-item">
              <div className="laboral-info-item-header">
                <h4>
                  Fecha de ingreso
                  {redDot()}
                </h4>
                {errorDate && (
                  <span className="laboral-info-item-error">
                    Campo obligatorio
                  </span>
                )}
              </div>
              <DatePicker
                format="DD/MM/YYYY"
                placeholder="Fecha de ingreso"
                style={{ width: "100%" }}
                value={this.state.dateAdmissionSelected}
                disabledDate={(current) => current && current > moment().endOf("day")}
                onChange={(date) => {
                  this.setState(
                    {
                      dateAdmissionSelected: date,
                      disabledButton: false,
                    },
                    () => this.onKeyUpClean(7)
                  )
                }}
              />
            </div>
            <div className="laboral-info-item">
              <div className="laboral-info-item-header">
                <h4>Líder</h4>
              </div>
              <Select
                loading={isLoadingLeaders}
                disabled={isLoadingLeaders}
                style={{ width: "100%" }}
                placeholder="Seleccionar líder"
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                onChange={(e) => {
                  this.onSelectChange("id_employee_leader", e)
                }}>
                {leaders.map((leader) => {
                  return (
                    <Option key={leader.id_employee} value={leader.id_employee}>
                      {leader.full_name}
                    </Option>
                  )
                })}
              </Select>
            </div>
          </div>

          <div className="laboral-info-input-group">
            <div style={{ maxWidth: "70%" }}>
              <div>
                <div className="laboral-info-input-group-tittles">
                  <span>Ubicación geográfica</span>
                </div>
                <InputGroup compact>
                  <Select
                    loading={isLoadingLocations}
                    disabled={isLoadingLocations}
                    style={{ width: "100%" }}
                    placeholder="Seleccionar ubicación geográfica"
                    onChange={(e) =>
                      this.onSelectChange("id_geographic_location", e)
                    }>
                    {locations.map((location) => {
                      return (
                        <Option
                          key={location.id_group}
                          value={location.id_group}>
                          {location.name}
                        </Option>
                      )
                    })}
                  </Select>
                </InputGroup>
              </div>
            </div>
            <div style={{ display: "grid" }}>
              <div className= {`create-end-buttons ${hasFreshchat ? "buttonsFooterMarginC" : ""}`}>
                <Button
                  type="ghost"
                  className="buttonRetry"
                  onClick={() => {
                    woopraTrack("Cancelar Crear Colaborador")
                    this.props.history.push("/organization#collaborators")
                  }}>
                  Cancelar
                </Button>
                <Button
                  type="primary"
                  disabled={this.state.disabledButton}
                  onClick={this.onCreate}
                  loading={isCreating}>
                  Guardar
                </Button>
              </div>
            </div>
          </div>
        </div>
        <ModalCustom
          modalOpen={this.state.modalBackOpen}
          showFooter
          onOk={() => this.props.history.push("/organization#collaborators")}
          onCancel={() => this.setState({ modalBackOpen: false })}>
          <img src={alertSvg} className="alertIcon" />
          <span style={{ fontWeight: 600, fontSize: 14 }}>
            ¿Estás seguro de que deseas salir sin guardar los cambios?
          </span>
        </ModalCustom>
      </div>
    )
  }
}

CollaboratorsCreateTemplate.propTypes = {}

export default CollaboratorsCreateTemplate
